module.exports = __webpack_public_path__ + "media/images/edge_icon-88c219e7f824d0d93697989c5754c082.png";